import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-91ed8b4c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-title" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"color":"#AAABAC","letter-spacing":"0.3rem"} }, "PRODUCTS & SERVICES", -1))
const _hoisted_3 = {
  class: "title",
  style: {"display":"flex","align-items":"center","color":"#FFFFFF","letter-spacing":"0.4rem","margin":"7px 0"}
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode("产 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("品 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("& ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("服 ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("务 ")
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "desc",
  style: {"color":"rgba(255,255,255,0.8)","font-weight":"500","letter-spacing":"0.17rem"}
}, "安全、稳定、可信赖的产品与服务", -1))
const _hoisted_10 = { class: "case-content" }
const _hoisted_11 = ["src", "alt"]
const _hoisted_12 = { class: "img-font" }
const _hoisted_13 = { style: {"width":"25px"} }
const _hoisted_14 = ["src", "alt"]
const _hoisted_15 = { style: {"width":"180px","display":"flex","justify-content":"space-between","align-items":"center","cursor":"pointer"} }
const _hoisted_16 = { style: {"color":"rgba(255,255,255,1)","font-size":"20px","overflow":"hidden","text-overflow":"ellipsis"} }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "to_right" }, null, -1))
const _hoisted_18 = { style: {"width":"215px","color":"rgba(255,255,255,0.7)","margin-top":"5px","font-size":"16px","overflow":"hidden","justify-content":"space-between","text-overflow":"ellipsis"} }
const _hoisted_19 = ["src", "alt"]
const _hoisted_20 = { class: "img-font" }
const _hoisted_21 = { style: {"width":"25px"} }
const _hoisted_22 = ["src", "alt"]
const _hoisted_23 = { style: {"width":"180px","display":"flex","justify-content":"space-between","align-items":"center","cursor":"pointer"} }
const _hoisted_24 = { style: {"color":"rgba(255,255,255,1)","font-size":"20px","overflow":"hidden","text-overflow":"ellipsis"} }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "to_right" }, null, -1))
const _hoisted_26 = { style: {"width":"180px","color":"rgba(255,255,255,0.7)","margin-top":"5px","font-size":"16px","overflow":"hidden","justify-content":"space-between","text-overflow":"ellipsis"} }
const _hoisted_27 = ["src", "alt"]
const _hoisted_28 = { class: "img-font" }
const _hoisted_29 = { style: {"width":"25px"} }
const _hoisted_30 = ["src", "alt"]
const _hoisted_31 = { style: {"width":"180px","display":"flex","justify-content":"space-between","align-items":"center","cursor":"pointer"} }
const _hoisted_32 = { style: {"color":"rgba(255,255,255,1)","font-size":"20px","overflow":"hidden","text-overflow":"ellipsis"} }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "to_right" }, null, -1))
const _hoisted_34 = { style: {"width":"180px","color":"rgba(255,255,255,0.7)","margin-top":"5px","font-size":"16px","overflow":"hidden","justify-content":"space-between","text-overflow":"ellipsis"} }
const _hoisted_35 = ["src", "alt"]
const _hoisted_36 = { class: "img-font" }
const _hoisted_37 = { style: {"width":"25px"} }
const _hoisted_38 = ["src", "alt"]
const _hoisted_39 = { style: {"width":"180px","display":"flex","justify-content":"space-between","align-items":"center","cursor":"pointer"} }
const _hoisted_40 = { style: {"color":"rgba(255,255,255,1)","font-size":"20px","overflow":"hidden","text-overflow":"ellipsis"} }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "to_right" }, null, -1))
const _hoisted_42 = { style: {"width":"180px","color":"rgba(255,255,255,0.7)","margin-top":"5px","font-size":"16px","overflow":"hidden","justify-content":"space-between","text-overflow":"ellipsis"} }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "arrow5 left" }, null, -1))
const _hoisted_44 = ["src", "alt"]
const _hoisted_45 = { class: "img-font" }
const _hoisted_46 = { style: {"width":"25px"} }
const _hoisted_47 = ["src", "alt"]
const _hoisted_48 = { style: {"width":"180px","display":"flex","justify-content":"space-between","align-items":"center","cursor":"pointer"} }
const _hoisted_49 = { style: {"color":"rgba(255,255,255,1)","font-size":"20px","overflow":"hidden","text-overflow":"ellipsis"} }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "to_right" }, null, -1))
const _hoisted_51 = { style: {"width":"180px","color":"rgba(255,255,255,0.7)","margin-top":"5px","font-size":"16px","overflow":"hidden","justify-content":"space-between","text-overflow":"ellipsis"} }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "arrow5 right" }, null, -1))
const _hoisted_53 = ["src", "alt"]
const _hoisted_54 = { class: "img-font" }
const _hoisted_55 = { style: {"width":"25px"} }
const _hoisted_56 = ["src", "alt"]
const _hoisted_57 = { style: {"width":"180px","display":"flex","justify-content":"space-between","align-items":"center","cursor":"pointer"} }
const _hoisted_58 = { style: {"color":"rgba(255,255,255,1)","font-size":"20px","overflow":"hidden","text-overflow":"ellipsis"} }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "to_right" }, null, -1))
const _hoisted_60 = { style: {"width":"180px","color":"rgba(255,255,255,0.7)","margin-top":"5px","font-size":"16px","overflow":"hidden","justify-content":"space-between","text-overflow":"ellipsis"} }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "arrow7 left" }, null, -1))
const _hoisted_62 = ["src", "alt"]
const _hoisted_63 = { class: "img-font" }
const _hoisted_64 = { style: {"width":"25px"} }
const _hoisted_65 = ["src", "alt"]
const _hoisted_66 = { style: {"width":"180px","display":"flex","justify-content":"space-between","align-items":"center","cursor":"pointer"} }
const _hoisted_67 = { style: {"color":"rgba(255,255,255,1)","font-size":"20px","overflow":"hidden","text-overflow":"ellipsis"} }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "to_right" }, null, -1))
const _hoisted_69 = { style: {"width":"180px","color":"rgba(255,255,255,0.7)","margin-top":"5px","font-size":"16px","overflow":"hidden","justify-content":"space-between","text-overflow":"ellipsis"} }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "arrow7 right" }, null, -1))

import { onMounted, ref } from "vue";
import type { TabsPaneContext } from "element-plus";
import icon1 from "../../../public/img/home/case/3-title_1.png";
import icon2 from "../../../public/img/home/case/3-title_2.png";
import icon3 from "../../../public/img/home/case/3-title_3.png";
import icon4 from "../../../public/img/home/case/3-title_4.png";
import icon5 from "../../../public/img/home/case/3-title_5.png";
import icon6 from "../../../public/img/home/case/3-title_6.png";
import icon7 from "../../../public/img/home/case/3-title_7.png";
import icon8 from "../../../public/img/home/case/3-title_8.png";

import image1 from "../../../public/img/home/case/case1.png";
import image2 from "../../../public/img/home/case/case2.png";
import image3 from "../../../public/img/home/case/case3.png";
import image4 from "../../../public/img/home/case/case4.png";
import image21 from "../../../public/img/home/case/case21.png";
import image22 from "../../../public/img/home/case/case22.png";
import image23 from "../../../public/img/home/case/case23.png";
import image24 from "../../../public/img/home/case/case24.png";
import image25 from "../../../public/img/home/case/case25.png";
import image26 from "../../../public/img/home/case/case26.png";
import image27 from "../../../public/img/home/case/case27.png";
import image28 from "../../../public/img/home/case/case28.png";
import image31 from "../../../public/img/home/case/case31.png";
import image32 from "../../../public/img/home/case/case32.png";
import image33 from "../../../public/img/home/case/case33.png";
import image34 from "../../../public/img/home/case/case34.png";
import image41 from "../../../public/img/home/case/case41.png";
import image42 from "../../../public/img/home/case/case42.png";
import image43 from "../../../public/img/home/case/case43.png";
import image44 from "../../../public/img/home/case/case44.png";
import image45 from "../../../public/img/home/case/case45.png";
import image46 from "../../../public/img/home/case/case46.png";
import image51 from "../../../public/img/home/case/case51.png";
import image52 from "../../../public/img/home/case/case52.png";
import image53 from "../../../public/img/home/case/case53.png";
import image61 from "../../../public/img/home/case/case61.png";
import image62 from "../../../public/img/home/case/case62.png";
import image63 from "../../../public/img/home/case/case63.png";
import image64 from "../../../public/img/home/case/case64.png";
import image65 from "../../../public/img/home/case/case65.png";
import image66 from "../../../public/img/home/case/case66.png";
import image71 from "../../../public/img/home/case/case71.png";
import image72 from "../../../public/img/home/case/case72.png";
import image73 from "../../../public/img/home/case/case73.png";


export default /*#__PURE__*/_defineComponent({
  __name: 'Case',
  setup(__props) {

const activeName = ref("first");
const imageContainer = ref<HTMLDivElement | null>(null);
const imageContainer4 = ref<HTMLDivElement | null>(null);
const imageContainer6 = ref<HTMLDivElement | null>(null);

const images = ref([
  {
    src: image1,
    alt: "Image 1",
    icons: icon1,
    head: "婚嫁互娱",
    font: "首推婚礼现场IoT互动娱乐平台",
  },
  {
    src: image2,
    alt: "Image 2",
    icons: icon2,
    head: "婚礼管家",
    font: "一站式婚礼堂智能管理平台",
  },
  {
    src: image3,
    alt: "Image 3",
    icons: icon3,
    head: "婚礼请柬",
    font: "多场景营销婚礼电子请柬",
  },
  {
    src: image4,
    alt: "Image 4",
    icons: icon4,
    head: "婚庆电子名片",
    font: "打通婚嫁企业营销第一步",
  },
]);
const images2 = ref([
  {
    src: image21,
    alt: "Image 1",
    icons: icon1,
    head: "进销存云",
    font: "采购、销售、库存、资金全链路管理",
  },
  {
    src: image22,
    alt: "Image 2",
    icons: icon2,
    head: "财务云",
    font: "多组织多核算体系，阿米巴经营会计",
  },
  {
    src: image23,
    alt: "Image 3",
    icons: icon3,
    head: "生产云",
    font: "效率，实现全流程数字化管控",
  },
  {
    src: image24,
    alt: "Image 4",
    icons: icon4,
    head: "电商云",
    font: "业财税一体化，多平台订单对接及快速处理",
  },
  {
    src: image25,
    alt: "Image 4",
    icons: icon5,
    head: "零售云",
    font: "高效收银、精准营销，智能要货配货",
  },
  {
    src: image26,
    alt: "Image 4",
    icons: icon6,
    head: "订货云",
    font: "将生意搬上互联网，客户自助订货",
  },
  {
    src: image27,
    alt: "Image 4",
    icons: icon7,
    head: "税务云",
    font: "凭证、报表分析、税务等全面管理",
  },
  {
    src: image28,
    alt: "Image 4",
    icons: icon8,
    head: "数据服务云",
    font: "移动取数，异构数据整合，大数据算法模型",
  },
]);
const images3 = ref([
  {
    src: image31,
    alt: "Image 1",
    icons: icon1,
    head: "社区团购",
    font: "采购、销售、库存、资金全链路管理",
  },
  {
    src: image32,
    alt: "Image 2",
    icons: icon2,
    head: "餐饮外卖",
    font: "多组织多核算体系，阿米巴经营会计",
  },
  {
    src: image33,
    alt: "Image 3",
    icons: icon3,
    head: "水产生鲜",
    font: "效率，实现全流程数字化管控",
  },
  {
    src: image34,
    alt: "Image 4",
    icons: icon4,
    head: "电商商城",
    font: "业财税一体化，多平台订单对接及快速处理",
  },
]);
const images4 = ref([
  {
    src: image41,
    alt: "Image 1",
    icons: icon1,
    head: "MK数字工作平台",
    font: "让大企业突破传统OA瓶颈",
  },
  {
    src: image42,
    alt: "Image 2",
    icons: icon2,
    head: "中大型数字化OA",
    font: "全面数字化，提效大协同",
  },
  {
    src: image43,
    alt: "Image 3",
    icons: icon3,
    head: "中小型数字化OA",
    font: "小快轻准  办公不止高效",
  },
  {
    src: image44,
    alt: "Image 4",
    icons: icon4,
    head: "信创OA",
    font: "基于信创体系的数字化办公",
  },
  {
    src: image45,
    alt: "Image 4",
    icons: icon5,
    head: "业务管理云OA",
    font: "让企业业务经营更简单",
  },
  {
    src: image46,
    alt: "Image 4",
    icons: icon6,
    head: "KMS知识管理平台",
    font: "让组织知识转化为财富",
  },
]);
const images5 = ref([
  {
    src: image51,
    alt: "Image 1",
    icons: icon1,
    head: "商城权益",
    font: "商城权益赋能企业会员营销场景",
  },
  {
    src: image52,
    alt: "Image 2",
    icons: icon2,
    head: "礼品卡权益",
    font: "礼品卡权益线上营销夯实用户粘性",
  },
  {
    src: image53,
    alt: "Image 3",
    icons: icon3,
    head: "会员体系",
    font: "会员体系丰富企业营销手法",
  },
]);
const images6 = ref([
  {
    src: image61,
    alt: "Image 1",
    icons: icon1,
    head: "数据库",
    font: "可靠易用免维护的数据服务",
  },
  {
    src: image62,
    alt: "Image 2",
    icons: icon2,
    head: "弹性计算",
    font: "稳定、安全的弹性计算服务",
  },
  {
    src: image63,
    alt: "Image 3",
    icons: icon3,
    head: "存储",
    font: "高性能、大规模分布式对象储存",
  },
  {
    src: image64,
    alt: "Image 4",
    icons: icon4,
    head: "安全",
    font: "云主机安全防护、精准防御",
  },
  {
    src: image65,
    alt: "Image 4",
    icons: icon5,
    head: "网络与CDN",
    font: "安全隔离的网络空间",
  },
  {
    src: image66,
    alt: "Image 4",
    icons: icon6,
    head: "容器与中间件",
    font: "高可靠、高可用、高处理性能",
  },
]);
const images7 = ref([
  {
    src: image71,
    alt: "Image 1",
    icons: icon1,
    head: "电子名片",
    font: "名片数字化赋能企业科技属性",
  },
  {
    src: image72,
    alt: "Image 2",
    icons: icon2,
    head: "聚合支付",
    font: "聚合支付开拓企业支付多元化",
  },
  {
    src: image73,
    alt: "Image 3",
    icons: icon3,
    head: "电子邀请函",
    font: "打通企业多元营销第一点",
  },
]);


const scrollLeft = () => {
  if (!imageContainer.value) return;
  imageContainer.value.scrollBy({
    left: -imageContainer.value.offsetWidth,
    behavior: "smooth",
  });
  if (!imageContainer4.value) return;
  imageContainer4.value.scrollBy({
    left: -imageContainer4.value.offsetWidth,
    behavior: "smooth",
  });
  if (!imageContainer6.value) return;
  imageContainer6.value.scrollBy({
    left: -imageContainer6.value.offsetWidth,
    behavior: "smooth",
  });
  updateArrows();
};
const scrollRight = () => {
  if (!imageContainer.value) return;
  imageContainer.value.scrollBy({
    left: imageContainer.value.offsetWidth,
    behavior: "smooth",
  });
  if (!imageContainer4.value) return;
  imageContainer4.value.scrollBy({
    left: imageContainer4.value.offsetWidth,
    behavior: "smooth",
  });
  if (!imageContainer6.value) return;
  imageContainer6.value.scrollBy({
    left: imageContainer6.value.offsetWidth,
    behavior: "smooth",
  });
  updateArrows();
};
const updateArrows = () => {
  if (!imageContainer.value) return;
  const leftArrow = document.querySelector(".left") as HTMLButtonElement | null;
  const rightArrow = document.querySelector(
    ".right"
  ) as HTMLButtonElement | null;
  if (leftArrow) {
    leftArrow.disabled = imageContainer.value.scrollLeft === 0;
  }
  if (rightArrow) {
    rightArrow.disabled =
      imageContainer.value.scrollLeft + imageContainer.value.offsetWidth >=
      imageContainer.value.scrollWidth;
  }

  if (!imageContainer4.value) return;
  const leftArrow4 = document.querySelector(
    ".left4"
  ) as HTMLButtonElement | null;
  const rightArrow4 = document.querySelector(
    ".right4"
  ) as HTMLButtonElement | null;
  if (leftArrow4) {
    leftArrow4.disabled = imageContainer4.value.scrollLeft === 0;
  }
  if (rightArrow4) {
    rightArrow4.disabled =
      imageContainer4.value.scrollLeft + imageContainer4.value.offsetWidth >=
      imageContainer4.value.scrollWidth;
  }

  if (!imageContainer6.value) return;
  const leftArrow6 = document.querySelector(
    ".left6"
  ) as HTMLButtonElement | null;
  const rightArrow6 = document.querySelector(
    ".right6"
  ) as HTMLButtonElement | null;
  if (leftArrow6) {
    leftArrow6.disabled = imageContainer6.value.scrollLeft === 0;
  }
  if (rightArrow6) {
    rightArrow6.disabled =
      imageContainer6.value.scrollLeft + imageContainer6.value.offsetWidth >=
      imageContainer6.value.scrollWidth;
  }
};
onMounted(() => {
  updateArrows();
});
// const scrollRight = () => {
//   if (imageContainer.value) {
//     imageContainer.value.scrollLeft += 200;
//   }
// };

const handleClick = (tab: TabsPaneContext, event: Event) => {
  console.log(tab, event);
};

return (_ctx: any,_cache: any) => {
  const _component_sapn = _resolveComponent("sapn")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("p", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_sapn, { class: "shu" }),
        _hoisted_5,
        _createVNode(_component_sapn, { class: "shu" }),
        _hoisted_6,
        _createVNode(_component_sapn, { class: "shu" }),
        _hoisted_7,
        _createVNode(_component_sapn, { class: "shu" }),
        _hoisted_8
      ]),
      _hoisted_9
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_el_tabs, {
        modelValue: activeName.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeName).value = $event)),
        class: "demo-tabs",
        onTabClick: handleClick
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_tab_pane, {
            label: "数字婚嫁",
            name: "first"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "image-container",
                ref_key: "imageContainer",
                ref: imageContainer
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(images.value, (image, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "image"
                  }, [
                    _createElementVNode("img", {
                      src: image.src,
                      alt: image.alt,
                      style: {"width":"250px","cursor":"pointer"}
                    }, null, 8, _hoisted_11),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("img", {
                          src: image.icons,
                          alt: image.alt,
                          style: {"width":"115%","min-width":"20px"}
                        }, null, 8, _hoisted_14)
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, _toDisplayString(image.head), 1),
                          _hoisted_17
                        ]),
                        _createElementVNode("div", _hoisted_18, _toDisplayString(image.font), 1)
                      ])
                    ])
                  ]))
                }), 128))
              ], 512)
            ]),
            _: 1
          }),
          _createVNode(_component_el_tab_pane, {
            label: "数字业财税",
            name: "second"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "arrow left",
                onClick: scrollLeft
              }, "‹"),
              _createElementVNode("div", {
                class: "image-container4",
                ref_key: "imageContainer",
                ref: imageContainer
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(images2.value, (image2, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "image"
                  }, [
                    _createElementVNode("img", {
                      src: image2.src,
                      alt: image2.alt,
                      style: {"width":"250px","cursor":"pointer"}
                    }, null, 8, _hoisted_19),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("img", {
                          src: image2.icons,
                          alt: image2.alt,
                          style: {"width":"115%","min-width":"20px"}
                        }, null, 8, _hoisted_22)
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("div", _hoisted_24, _toDisplayString(image2.head), 1),
                          _hoisted_25
                        ]),
                        _createElementVNode("div", _hoisted_26, _toDisplayString(image2.font), 1)
                      ])
                    ])
                  ]))
                }), 128))
              ], 512),
              _createElementVNode("div", {
                class: "arrow right",
                onClick: scrollRight
              }, "›")
            ]),
            _: 1
          }),
          _createVNode(_component_el_tab_pane, {
            label: "数字零售",
            name: "third"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "image-container",
                ref_key: "imageContainer",
                ref: imageContainer
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(images3.value, (image3, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "image"
                  }, [
                    _createElementVNode("img", {
                      src: image3.src,
                      alt: image3.alt,
                      style: {"width":"250px","cursor":"pointer"}
                    }, null, 8, _hoisted_27),
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("img", {
                          src: image3.icons,
                          alt: image3.alt,
                          style: {"width":"115%","min-width":"20px"}
                        }, null, 8, _hoisted_30)
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("div", _hoisted_32, _toDisplayString(image3.head), 1),
                          _hoisted_33
                        ]),
                        _createElementVNode("div", _hoisted_34, _toDisplayString(image3.font), 1)
                      ])
                    ])
                  ]))
                }), 128))
              ], 512)
            ]),
            _: 1
          }),
          _createVNode(_component_el_tab_pane, {
            label: "数字办公",
            name: "four"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "arrow left4",
                onClick: scrollLeft
              }, "‹"),
              _createElementVNode("div", {
                class: "image-container4",
                ref_key: "imageContainer4",
                ref: imageContainer4
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(images4.value, (image4, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "image"
                  }, [
                    _createElementVNode("img", {
                      src: image4.src,
                      alt: image4.alt,
                      style: {"width":"250px","cursor":"pointer"}
                    }, null, 8, _hoisted_35),
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("img", {
                          src: image4.icons,
                          alt: image4.alt,
                          style: {"width":"115%","min-width":"20px"}
                        }, null, 8, _hoisted_38)
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_39, [
                          _createElementVNode("div", _hoisted_40, _toDisplayString(image4.head), 1),
                          _hoisted_41
                        ]),
                        _createElementVNode("div", _hoisted_42, _toDisplayString(image4.font), 1)
                      ])
                    ])
                  ]))
                }), 128))
              ], 512),
              _createElementVNode("div", {
                class: "arrow right4",
                onClick: scrollRight
              }, "›")
            ]),
            _: 1
          }),
          _createVNode(_component_el_tab_pane, {
            label: "数字权益",
            name: "five"
          }, {
            default: _withCtx(() => [
              _hoisted_43,
              _createElementVNode("div", {
                class: "image-container",
                ref_key: "imageContainer",
                ref: imageContainer
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(images5.value, (image5, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "image"
                  }, [
                    _createElementVNode("img", {
                      src: image5.src,
                      alt: image5.alt,
                      style: {"width":"250px","cursor":"pointer"}
                    }, null, 8, _hoisted_44),
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("div", _hoisted_46, [
                        _createElementVNode("img", {
                          src: image5.icons,
                          alt: image5.alt,
                          style: {"width":"115%","min-width":"20px"}
                        }, null, 8, _hoisted_47)
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_48, [
                          _createElementVNode("div", _hoisted_49, _toDisplayString(image5.head), 1),
                          _hoisted_50
                        ]),
                        _createElementVNode("div", _hoisted_51, _toDisplayString(image5.font), 1)
                      ])
                    ])
                  ]))
                }), 128))
              ], 512),
              _hoisted_52
            ]),
            _: 1
          }),
          _createVNode(_component_el_tab_pane, {
            label: "云产品",
            name: "six"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "arrow left6",
                onClick: scrollLeft
              }, "‹"),
              _createElementVNode("div", {
                class: "image-container6",
                ref_key: "imageContainer6",
                ref: imageContainer6
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(images6.value, (image6, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "image"
                  }, [
                    _createElementVNode("img", {
                      src: image6.src,
                      alt: image6.alt,
                      style: {"width":"250px","cursor":"pointer"}
                    }, null, 8, _hoisted_53),
                    _createElementVNode("div", _hoisted_54, [
                      _createElementVNode("div", _hoisted_55, [
                        _createElementVNode("img", {
                          src: image6.icons,
                          alt: image6.alt,
                          style: {"width":"115%","min-width":"20px"}
                        }, null, 8, _hoisted_56)
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_57, [
                          _createElementVNode("div", _hoisted_58, _toDisplayString(image6.head), 1),
                          _hoisted_59
                        ]),
                        _createElementVNode("div", _hoisted_60, _toDisplayString(image6.font), 1)
                      ])
                    ])
                  ]))
                }), 128))
              ], 512),
              _createElementVNode("div", {
                class: "arrow right6",
                onClick: scrollRight
              }, "›")
            ]),
            _: 1
          }),
          _createVNode(_component_el_tab_pane, {
            label: "数字服务",
            name: "seven"
          }, {
            default: _withCtx(() => [
              _hoisted_61,
              _createElementVNode("div", {
                class: "image-container",
                ref_key: "imageContainer",
                ref: imageContainer
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(images7.value, (image7, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "image"
                  }, [
                    _createElementVNode("img", {
                      src: image7.src,
                      alt: image7.alt,
                      style: {"width":"250px","cursor":"pointer"}
                    }, null, 8, _hoisted_62),
                    _createElementVNode("div", _hoisted_63, [
                      _createElementVNode("div", _hoisted_64, [
                        _createElementVNode("img", {
                          src: image7.icons,
                          alt: image7.alt,
                          style: {"wwidth":"115%","min-width":"20px"}
                        }, null, 8, _hoisted_65)
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_66, [
                          _createElementVNode("div", _hoisted_67, _toDisplayString(image7.head), 1),
                          _hoisted_68
                        ]),
                        _createElementVNode("div", _hoisted_69, _toDisplayString(image7.font), 1)
                      ])
                    ])
                  ]))
                }), 128))
              ], 512),
              _hoisted_70
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ], 64))
}
}

})